<template>
  <div style="padding: 10px">
    <v-app-bar flat color="white">
      <v-spacer/>
      <v-app-bar-title class="centered-title">{{$t("IrrigationOrdersTable.irrigationOrders")}} {{pageNumber}}</v-app-bar-title>
      <v-progress-circular
        class="loading-icon"
        v-if="loading"
        indeterminate
        size="20"
        width="3"
        color="#0098E1"
      ></v-progress-circular>
      <v-spacer/>
    </v-app-bar>
    <v-data-table
      :headers="headers"
      :items="dataTable"
      hide-default-footer
      class="elevation-1 text-center table-content"
    >
      <template v-slot:items="props" v-if="!loading">
        <td class="text-center">{{ props.item.irrigationOrderId }}</td>
        <td class="text-center">{{ props.item.deviceName }}</td>
        <td class="text-center">{{ props.item.plotName }}</td>
        <td class="text-center">{{ props.item.from }}</td>
        <td class="text-center">{{ props.item.to }}</td>
        <td class="text-center">{{ props.item.mm }}</td>
        <td class="text-center">{{ props.item.theoricHours }}</td>
        <td class="text-center">{{ props.item.diffTimeHours }}</td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {makeFetchQueryRequest} from '../../lib/helpers'
import {auth} from '../../plugins/firebase'
export default {
  props: ['limit', 'offset', 'pageNumber', 'timeRange', 'organizationId', 'uniqueIrrigationOrders'],
  data () {
    return {
      selected: [],
      headers: [
        {
          text: this.$t('IrrigationOrdersTable.irrigationOrder'),
          align: 'center',
          sortable: false,
          value: 'irrigationOrderId'
        },
        { text: this.$t('IrrigationOrdersTable.device'), align: 'center', value: 'deviceName' },
        { text: this.$t('IrrigationOrdersTable.lot'), align: 'center', value: 'plotName' },
        { text: this.$t('IrrigationOrdersTable.startDate'), align: 'center', value: 'from' },
        { text: this.$t('IrrigationOrdersTable.endDate'), align: 'center', value: 'to' },
        { text: this.$t('IrrigationOrdersTable.mm'), align: 'center', value: 'mm' },
        { text: this.$t('IrrigationOrdersTable.theoricHoursShort'), align: 'center', value: 'theoricHours' },
        { text: this.$t('IrrigationOrdersTable.accumulatedHoursShort'), align: 'center', value: 'diffTimeHours' }
      ],
      dataTable: [],
      loading: false
    }
  },
  created () {
    this.getDataTable(this.timeRange.from, this.timeRange.to, this.organizationId)
  },
  watch: {
    timeRange (value) {
      this.getDataTable(value.from, value.to, this.organizationId)
    },
    organizationId (value) {
      this.getDataTable(this.timeRange.from, this.timeRange.to, value)
    }
  },
  methods: {
    async getDataTable (fromDate, toDate, organizationId) {
      if (fromDate && toDate) {
        this.loading = true
        const fetchBody = {
          type: 'organizationIrrigationOrders',
          data: {
            organizationId,
            fromDate: fromDate.getTime(),
            toDate: toDate.getTime()
          }
        }
        try {
          const res = await makeFetchQueryRequest(fetchBody, auth.currentUser)
          let uniqueIrrigationOrders = []
          res.forEach(elem => {
            const currentIndex = uniqueIrrigationOrders.findIndex(order => order.irrigationOrderId === elem.irrigationOrderId && order.plotName === elem.plotName)
            if (currentIndex === -1) {
              uniqueIrrigationOrders.push(elem)
            } else {
              uniqueIrrigationOrders[currentIndex].diffTimeHours += elem.diffTimeHours
            }
          })

          uniqueIrrigationOrders = this.$ponceConfig.sortArrayByDeviceName(uniqueIrrigationOrders)
          uniqueIrrigationOrders = uniqueIrrigationOrders.slice((this.pageNumber - 1) * this.limit, (this.pageNumber) * this.limit)
          uniqueIrrigationOrders.forEach((elem) => {
            elem.from = new Date(elem.from).toLocaleDateString('es-AR', {day: '2-digit', month: '2-digit', year: 'numeric'})
            elem.to = new Date(elem.to).toLocaleDateString('es-AR', {day: '2-digit', month: '2-digit', year: 'numeric'})
            if (elem.theoricHours) {
              elem.theoricHours = elem.theoricHours.toFixed(2)
            }
            if (elem.diffTimeHours) {
              elem.diffTimeHours = elem.diffTimeHours.toFixed(2)
            }
          })
          this.$emit('update:uniqueIrrigationOrders', uniqueIrrigationOrders)
          this.dataTable = uniqueIrrigationOrders
        } catch (error) {
          console.log(error.message)
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// IrrigationOrdersTable.vue?e797ad62